module.exports = __webpack_public_path__ + "img/sketch_new_consultant_wide.cad0aaa7.png";